export default "__VITE_ASSET__BIWzQh9$__"